<template>
  <HeadlessTransitionRoot as="template" :show="open">
    <HeadlessDialog as="div" class="relative z-10" @close="close()">
      <HeadlessTransitionChild
        as="template"
        enter="ease-in-out duration-500"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-500"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-y-0 top-28 right-11 flex max-w-full pl-10"
          >
            <HeadlessTransitionChild
              as="template"
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
            >
              <HeadlessDialogPanel
                class="pointer-events-auto w-screen max-w-md text-white"
              >
                <div
                  class="flex max-h-screen flex-col bg-Primary-800 shadow-xl rounded-lg"
                >
                  <div
                    class="flex min-h-0 flex-1 flex-col overflow-y-auto py-6"
                  >
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <HeadlessDialogTitle
                          class="font-normal text-2xl leading-6"
                          >Filter</HeadlessDialogTitle
                        >
                        <div class="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            class="rounded-md text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                            @click="close()"
                          >
                            <span class="sr-only">Close panel</span>
                            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="relative mt-6 flex-1 px-8 sm:px-6">
                      <!-- Your content -->
                      <!-- filter as tags -->
                      <div v-if="showCategories">
                        <h2 class="text-2xl font-bold text-white border-t py-3">
                          Categories
                        </h2>
                        <div class="flex flex-wrap justify-start gap-2">
                          <filtersToggleBadge
                            v-for="[key, value] in categoriesFilter"
                            :key="key"
                            :category="key"
                            :enabled="value"
                            @update:enabled="toggle($event, key)"
                            :show-remove="false"
                          />
                        </div>
                      </div>
                      <div v-if="showMapType">
                        <h2 class="text-2xl font-bold text-white mt-6 py-3">
                          Colour Scale
                        </h2>                       

                        <HeadlessSwitchGroup
                          as="div"
                          class="flex items-center gap"
                        >
                          <HeadlessSwitchLabel
                            as="span"
                            class="mr-3 text-base cursor-pointer"
                          >
                            <span
                              :class="[
                                !ifStore.mapScaleSwitchBool
                                  ? 'text-white'
                                  : 'text-neutral-400/50',
                                'font-medium',
                              ]"
                              >Linear</span
                            >
                          </HeadlessSwitchLabel>
                          <HeadlessSwitch
                            v-model="ifStore.mapScaleSwitchBool"
                            class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none"
                          >
                            <span class="sr-only">Toggle map type</span>
                            <span
                              aria-hidden="true"
                              class="pointer-events-none absolute h-full w-full rounded-md"
                            />
                            <span
                              aria-hidden="true"
                              class="bg-white pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
                            />
                            <span
                              aria-hidden="true"
                              :class="[
                                ifStore.mapScaleSwitchBool
                                  ? 'translate-x-5'
                                  : 'translate-x-0',
                                'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full  bg-Primary-600 shadow ring-0 transition-transform duration-200 ease-in-out',
                              ]"
                            />
                          </HeadlessSwitch>
                          <HeadlessSwitchLabel
                            as="span"
                            class="ml-3 text-base cursor-pointer"
                          >
                            <span
                              :class="[
                                ifStore.mapScaleSwitchBool
                                  ? 'text-white'
                                  : 'text-neutral-400/50',
                                'font-medium',
                              ]"
                              >Quantile</span
                            >
                          </HeadlessSwitchLabel>
                        </HeadlessSwitchGroup>
                      </div>
                      <div>
                        <h2 class="text-2xl font-bold text-white mt-6 py-3">
                          Timeframe
                        </h2>
                        <div class="flex justify-between gap-4 items-center">
                          <span class="text-Primary-400 text-xs">{{
                            ifStore.minYear
                          }}</span>
                          <div class="flex-grow">
                            <Slider
                              v-model="ifStore.sliderYears"
                              :min="ifStore.minYear"
                              :max="ifStore.maxYear"
                              tooltipPosition="bottom"
                            ></Slider>
                          </div>
                          <span class="text-Primary-400 text-xs">{{
                            ifStore.maxYear
                          }}</span>
                        </div>
                      </div>

                      <!-- <div v-if="showFlows">
                        <h2 class="text-2xl font-bold text-white mt-6 py-3">
                          Flows
                        </h2>
                        <div class="space-y-5">
                          <div class="relative flex items-start" v-for=" (flow,i) in ifStore.flowTypes">
                            <div class="flex h-6 items-center">
                              <input
                                v-model="flow.active"
                                :id="flow.label"
                                :aria-describedby="flow.label+'-description'"
                                :name="flow.label"
                                type="checkbox"
                                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                              />
                            </div>
                            <div class="ml-3 text-sm leading-6">
                              <label
                                :for="flow.label"
                                class="font-medium text-white"
                                >{{ flow.label }}</label>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="border-b border-white mt-20"></div>

                      <!-- end content-->
                    </div>
                  </div>

                  <div class="flex flex-shrink-0 justify-between px-8 py-4">
                    <button
                      type="button"
                      class="rounded-md bg-white px-3 py-2 text-sm font-semibold text-Primary-800 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 tracking-widest"
                      @click="close()"
                    >
                      Ok
                    </button>
                    <a
                      href="#"
                      type="submit"
                      class="ml-4 inline-flex justify-center rounded-md underline px-3 py-2 text-sm font-semibold text-white shadow-sm tracking-wider"
                      @click.prevent="resetFilters()"
                    >
                      RESET
                    </a>
                  </div>
                </div>
              </HeadlessDialogPanel>
            </HeadlessTransitionChild>
          </div>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup>
import { XMarkIcon } from "@heroicons/vue/24/outline";
import Slider from "@vueform/slider";

const props = defineProps({
  showFlows: {
    type: Boolean,
    default: true,
  },
  showCategories: {
    type: Boolean,
    default: true,
  },
  showMapType: {
    type: Boolean,
    default: false,
  },
  open: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:open"]);

const close = () => {
  emit("update:open", false);
};

const store = useBaseDataStore();
const ifStore = useInterfaceStore();

ifStore.init();
const categoriesFilter = computed(() => {
  return ifStore.categoriesFilter;
});

const sliderYears = ifStore.sliderYears;
const minYear = ifStore.minYear;
const maxYear = ifStore.maxYear;
const toggle = (value, key) => {
  if (ifStore.isFilterActive === false && value === false) {
    ifStore.disableAllCategories(); // all selected- >click one -> one selected
    ifStore.categoriesFilter.set(key, true);
  }
  //one selected-> deselect -> all selected
  else if (
    ifStore.activeFilterKeys.length === 1 &&
    !value &&
    key === ifStore.activeFilterKeys[0]
  ) {
    ifStore.enableAllCategories();
  } else ifStore.categoriesFilter.set(key, value);
};
const resetFilters = () => {
  ifStore.resetAll();
};
</script>

<style src="@vueform/slider/themes/default.css"></style>

<style>
:root {
  --slider-tooltip-bg: #262e6a;
  --slider-bg: #7882cf;
  --slider-connect-bg: #fff;
  --slider-height: 1px;
  --slider-handle-width: 8px;
  --slider-handle-height: 8px;
  --slider-tooltip-arrow-size: 0px;
  --slider-tooltip-distance: 0px;
  --slider-handle-radius: 0px;
}

.slider-handle {
  transform: rotate(45deg);
}
.slider-tooltip {
  transform: rotate(-45deg) !important;
}
</style>
```
